<script setup lang="ts">
import type { ChampionshipRegistrationSelectTeamTask } from "@/model/championship/championship-registration-select-team-task"
import type { TasksProps } from "@/pages/Tasks/Tasks/tasks-props"
import { useHttpClient, useHttpGet } from "@/vf"
import { toRefs } from "vue"
import type { ChampionshipRegistrationApproveData } from "./championship-registration"

const props = defineProps<TasksProps<ChampionshipRegistrationSelectTeamTask>>()

const emit = defineEmits<{
    (e: "updated"): void
}>()

const { task } = toRefs(props)
const { data } = await useHttpGet<ChampionshipRegistrationApproveData>(
    `/championship/registration/${task.value.organizationId}/pay-invoice/${task.value.id}`,
)
const http = useHttpClient()

async function resetRegistration() {
    await http.post(`/championship/registration/${data.value.registrationId}/reset`)
    emit("updated")
}

async function deleteRegistration() {
    await http.post(`/championship/registration/${data.value.registrationId}/dev-delete`)
    emit("updated")
}
</script>
<template>
    <div class="p-5">
        <button class="btn btn-primary" @click="resetRegistration()">DEV: Zurücksetzen</button>
        <button class="btn btn-primary" @click="deleteRegistration()">DEV: Löschen</button>
    </div>
</template>
